import FieldPopover from "../../../fields3/generic/popover/popover"
import FieldProgress_Popover from "./components/popover/popover"
import FieldProgress_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldProgress_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldConfig from "../../proto/field-config"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldProgress_View from "./render/view"
import FieldProgress_ViewSmall from "./render/view-small"
import normalizeNumber from "../../import/normalize/normalize-number"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldProgress_TableCell from "./render/table/table-cell"
import FieldProgress_Editable from "./render/editable/editable"
import {FieldFilterType} from "../../proto/types"
import FieldProgress_ConditionForm from "./render/condition"
import {FIELD_CONDITIONS_NUMBER, FieldNumber_filterFunc} from "../../conditions/number"
import FieldProgress_TableCellCalculated from "./render/table/calculated/table-cell-calculated"
import FieldProgress_AggregateCell from "./render/aggregate/aggregate-cell"
import {AggregateFunctionType} from "../../../data-structures/aggregators/types"
import FieldProgress_BoardAggregate from "./render/aggregate/board-aggregate"
import FieldProgress_QuickFilterView from "./render/quick-filter-view"

export default class FieldProgress extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 100

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel              = "Progress"
        this.filterType             = FieldFilterType.NUMBER
        this.typeGroup              = GROUP_MISC
        this.typeDescription        = "Progress selector"
        this.icon                   = 'i5-percent'

        this.isSearchable           = false
        this.isFilterAvailable      = true

        this.conditionTypes         = FIELD_CONDITIONS_NUMBER

        _.assign(this.components, {
            PopoverMenu         : FieldProgress_Popover,
            FormValueNotEmpty   : FieldProgress_FormValueNotEmpty,
            InlineValueNotEmpty : FieldProgress_InlineValueNotEmpty,
        })

        this.renderComponents.view                  = FieldProgress_View
        this.renderComponents.viewSmall             = FieldProgress_ViewSmall

        this.renderComponents.editable              = FieldProgress_Editable
        this.renderComponents.tableCell             = FieldProgress_TableCell
        this.renderComponents.tableCellCalculated   = FieldProgress_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldProgress_AggregateCell
        this.renderComponents.boardAggregate        = FieldProgress_BoardAggregate

        this.renderComponents.filterForm            = FieldProgress_ConditionForm
        this.renderComponents.quickFilterView       = FieldProgress_QuickFilterView

        this.filterFunc                             = FieldNumber_filterFunc
    }

    groupValue(value: any) {
        if (value === null || value === undefined || value === 'null') return null
        return typeof value === 'string' ? parseInt(value) : value
    }

    groupLabel(value: any): string {
        const groupValue = this.groupValue(value)
        if (_.isNil(groupValue) || _.isNaN(groupValue)) return 'Not set'
        return `${groupValue}%`
    }

    sortValue(value: any, model?: any) {
        return !_.isNil(value) ? value : -1
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        let res: number | null = normalizeNumber(value)

        if (!_.isNil(res) && res >= 0 && res <= 100) {
            return res
        }
        return null
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE,
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.AVERAGE
    }
}
